/**
 * Copyright (C) SiteVision AB 2002-2026, all rights reserved
 */
import { initSvAutoComplete } from './svAutoComplete';

(function ($) {
  const pluginName = 'svAutoComplete';
  const dataKey = `plugin_${pluginName}`;

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, dataKey)) {
        console.warn(
          `WARNING: $.fn.svAutoComplete is deprecated and will be removed in a future release. Please remove Velocity template-level custom initialization.`,
        );
        const instance = initSvAutoComplete(this, options);

        if (instance) {
          $.data(this, dataKey, instance);
        }
      }
    });
  };
})(window.$svjq);
